import { api } from 'api';
import type { PaymentMethod } from 'types/PaymentMethod';
import { Url } from 'utils/constants';

export const changeOrderPaymentMethod = ({
  orderId,
  paymentMethod,
}: {
  orderId: string;
  paymentMethod: PaymentMethod;
}): Promise<void> =>
  api.put(`${Url.KITCHEN_MANAGEMENT_API_URL}/orders/${orderId}/payments`, {
    paymentMethod,
  });
